import React, { useState }from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Popconfirm, Button, Icon, message } from 'antd';
import { deleteEvent, getContact } from './../API';
import { s3 } from './../utils';
const { uniqBy } = require('lodash');

function ContactPopConfirm(props) {
  const session = useMappedState(state => state.session);
  const contactCandidateList = useMappedState(state => state.contactCandidateList);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const reloadContact = async (contactID) => {
    const response = await getContact(session.authToken, contactID);

    if (response.data.responseCode === 0) {
      dispatch({type: "INIT_CONTACT", payload: response.data.contact});

      //re-construct all available candidates from events
      const allCandidates = uniqBy(response.data.contact.events.filter(i => i.candidate).map(x => x.candidate), 'id');
      dispatch({
        type: "SET_CONTACT_CANDIDATES_LIST",
        payload: allCandidates.map(i => {
          return {
            ...i,
            ...{avatar: `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${i.id}.jpeg`}
          }
        })
      });

      if (contactCandidateList.candidate !== 'all'
          && !allCandidates.map(i => i.id).includes(contactCandidateList.candidate)) {
        dispatch({type: "SET_CONTACT_CANDIDATES_LIST_SELECTION", payload: 'all'});
      }
    }
  }

  const handelOnClickRemoveEvent = async (i, c) => {
    setLoading(true);
    const result = await deleteEvent(session.authToken, {id: i.id});

    if (result.data.responseCode === 0) {
      reloadContact(c);
      setLoading(false);
      message.success(result.data.message);
    }
    else {
      setLoading(false);
      dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
    }
  }

  return (
    <Popconfirm
      placement="left"
      title="Are you sure to delete this event?"
      onConfirm={() => handelOnClickRemoveEvent(props.event, props.contactID)}
      okText="Yes"
      cancelText="No"
    >
      <Button size="small">
        {
          loading ?
          <Icon type="loading" />
          :
          <Icon type="delete" />
        }
      </Button>
    </Popconfirm>
  );
}

export default ContactPopConfirm;
